<span class="ico ico-deposit-limit-shield"></span>

<div class="obg-m-multi-deposit-limit-header">
	<h1>{{ 'multi-deposit-limit.title' | translate }}</h1>
	<p>
		{{ 'multi-deposit-limit.description' | translate }}
		<a *ngIf="collapseDepositInfo" (click)="navigateToResponsibleGaming()">{{ 'general.read-more' | translate }}</a>
	</p>
</div>

<div
	class="deposit-limit-exceed-info-box"
	*ngIf="(multiDepositService.jurisdictionAndDepositLimits$ | async)?.currentWeeklyLimit &&
	isCovidMessageVisible((multiDepositService.jurisdictionAndDepositLimits$ | async)?.currentWeeklyLimit)"
>
	<span class="ico-information-circle"></span>
	<p>{{ 'multi-deposit-limit.covid19-message' | translate: { threshold: threshold} }}</p>
</div>

<ng-container
	*ngIf="(multiDepositService.jurisdictionAndDepositLimits$ | async)?.jurisdiction"
	[ngSwitch]="(multiDepositService.jurisdictionAndDepositLimits$ | async)?.jurisdiction"
>
	<obg-m-multi-deposit-form
		*ngSwitchCase="'COGA'"
		[showInputFields]="multiDepositService.isInputFieldsVisible$ | async"
		[currencySymbol]="multiDepositService.currencySymbol$ | async"
		[prefixCurrencySymbol]="true"
		[upcomingDepositLimits]="multiDepositService?.upcomingLimits"
		[currentDepositLimits]="multiDepositService?.currentLimits"
		[placeholder]="multiDepositService.placeholder"
		[forceInvalidForm]="multiDepositService.forceInvalidForm"
		[validationKey]="multiDepositService.validationKey"
		[multiDepositLimitFormGroup]="multiDepositService.multiDepositForm"
		[hasCurrentLimits]="(multiDepositService.jurisdictionAndDepositLimits$ | async)?.hasCurrentLimits"
		[monthlySuggestion]="multiDepositService.suggestions?.monthlyDepositLimit"
		[weeklySuggestion]="multiDepositService.suggestions?.weeklyDepositLimit"
		[setDepositLoading]="multiDepositService.isSetDepositLoading$ | async"
		[redirectToDeposit]="(multiDepositService.redirectToDeposit$ | async) || newLoginFlow"
		[sessionLimitsUnset]="multiDepositService.isSessionLimitMissing$ | async"
		[hideDepositLimitCalculatorBanner]="hideDepositLimitCalculatorBanner"
		(formSubmitted)="onSubmit($event)"
		(toggleInputFields)="toggleInputFields($event)"
	></obg-m-multi-deposit-form>

	<obg-m-multi-deposit-form
		*ngSwitchCase="'Sga'"
		[showInputFields]="multiDepositService.isInputFieldsVisible$ | async"
		[currencySymbol]="multiDepositService.currencySymbol$ | async"
		[upcomingDepositLimits]="multiDepositService?.upcomingLimits"
		[currentDepositLimits]="multiDepositService?.currentLimits"
		[placeholder]="multiDepositService.placeholder"
		[forceInvalidForm]="multiDepositService.forceInvalidForm"
		[validationKey]="multiDepositService.validationKey"
		[multiDepositLimitFormGroup]="multiDepositService.multiDepositForm"
		[hasCurrentLimits]="(multiDepositService.jurisdictionAndDepositLimits$ | async)?.hasCurrentLimits"
		[monthlySuggestion]="multiDepositService.suggestions?.monthlyDepositLimit"
		[weeklySuggestion]="multiDepositService.suggestions?.weeklyDepositLimit"
		[setDepositLoading]="multiDepositService.isSetDepositLoading$ | async"
		[redirectToDeposit]="(multiDepositService.redirectToDeposit$ | async) || newLoginFlow"
		[sessionLimitsUnset]="multiDepositService.isSessionLimitMissing$ | async"
		[autoFocusFirstField]="true"
		[hideDepositLimitCalculatorBanner]="hideDepositLimitCalculatorBanner"
		[hideInputHint]="isJurisdictionSga$ | async"
		(formSubmitted)="onSubmit($event)"
		(toggleInputFields)="toggleInputFields($event)"
	></obg-m-multi-deposit-form>

	<obg-m-multi-deposit-form
		*ngSwitchDefault
		[showInputFields]="multiDepositService.isInputFieldsVisible$ | async"
		[currencySymbol]="multiDepositService.currencySymbol$ | async"
		[upcomingDepositLimits]="multiDepositService?.upcomingLimits"
		[currentDepositLimits]="multiDepositService?.currentLimits"
		[placeholder]="multiDepositService.placeholder"
		[forceInvalidForm]="multiDepositService.forceInvalidForm"
		[validationKey]="multiDepositService.validationKey"
		[multiDepositLimitFormGroup]="multiDepositService.multiDepositForm"
		[hasCurrentLimits]="(multiDepositService.jurisdictionAndDepositLimits$ | async)?.hasCurrentLimits"
		[monthlySuggestion]="multiDepositService.suggestions?.monthlyDepositLimit"
		[weeklySuggestion]="multiDepositService.suggestions?.weeklyDepositLimit"
		[setDepositLoading]="multiDepositService.isSetDepositLoading$ | async"
		[redirectToDeposit]="(multiDepositService.redirectToDeposit$ | async) || newLoginFlow"
		[sessionLimitsUnset]="multiDepositService.isSessionLimitMissing$ | async"
		[autoFocusFirstField]="true"
		[hideDepositLimitCalculatorBanner]="hideDepositLimitCalculatorBanner"
		(formSubmitted)="onSubmit($event)"
		(toggleInputFields)="toggleInputFields($event)"
	></obg-m-multi-deposit-form>
</ng-container>

<div
	*ngIf="!collapseDepositInfo"
	class="caption"
	[innerHtml]="'multi-deposit-limit.information' | jurisdiction | translate"
></div>
